"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var typeChecks_1 = require("../utils/typeChecks");
var collection_1 = require("../utils/collection");
var BreakdownAnalysisQuery = /** @class */ (function (_super) {
    __extends(BreakdownAnalysisQuery, _super);
    function BreakdownAnalysisQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreakdownAnalysisQuery.prototype.initialize = function (executionOptions) {
    };
    BreakdownAnalysisQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, breakdownAnalysisOptions = _a.breakdownAnalysisOptions, _b = _a.options, options = _b === void 0 ? {} : _b;
        var response = {
            code: '',
        };
        if (breakdownAnalysisOptions) {
            Object.assign(response, breakdownAnalysisOptions);
        }
        if (options.breakdownAnalysis) {
            Object.assign(response, options.breakdownAnalysis);
        }
        return response;
    };
    BreakdownAnalysisQuery.prototype.getRawValue = function (executionOptions) {
        var instance = this.getPortfolioFromContext(executionOptions);
        if (typeChecks_1.isObject(instance)) {
            var response = this.getPortfolioAllocation(this.options, instance);
            var order_1 = this.options.order;
            if (order_1) {
                order_1 = order_1.map(function (item) { return item.toLowerCase(); });
                response = collection_1.sortBy((response || []), function (item) {
                    var label = (item.label || '').toLowerCase();
                    if (order_1) {
                        var index = order_1.indexOf(label);
                        if (index > -1) {
                            return index.toString();
                        }
                    }
                    return label;
                }, 'ASC');
            }
            return response;
        }
        return undefined;
    };
    BreakdownAnalysisQuery.prototype.getPortfolioAllocation = function (allocationOptions, portfolio) {
        var totalWeight = this.getTotalViableWeightFromPortfolio(allocationOptions, portfolio);
        return this.getCombinedAllocationValues(allocationOptions, portfolio.entities, totalWeight);
    };
    BreakdownAnalysisQuery.prototype.getCombinedAllocationValues = function (allocationOptions, portfolioEntities, totalWeight) {
        var allocationsByLabel = {};
        var _loop_1 = function (portfolioEntity) {
            var weight = this_1.getWeight(portfolioEntity);
            var allocation = this_1.getAllocation(allocationOptions, portfolioEntity);
            if (allocation && allocation.values) {
                allocation.values.forEach(function (allocationValue) {
                    var label = allocationValue.label, value = allocationValue.value;
                    var newValue = value * weight / totalWeight;
                    if (!allocationsByLabel[label]) {
                        allocationsByLabel[label] = Object.assign({}, allocationValue, { value: 0 });
                    }
                    if (allocationsByLabel[label]) {
                        allocationsByLabel[label].value += newValue;
                    }
                });
            }
        };
        var this_1 = this;
        for (var _i = 0, portfolioEntities_1 = portfolioEntities; _i < portfolioEntities_1.length; _i++) {
            var portfolioEntity = portfolioEntities_1[_i];
            _loop_1(portfolioEntity);
        }
        return Object.values(allocationsByLabel);
    };
    BreakdownAnalysisQuery.prototype.getTotalViableWeightFromPortfolio = function (allocationOptions, portfolio) {
        var _this = this;
        var total = 0;
        if (portfolio) {
            var entities = portfolio.entities;
            if (entities) {
                entities.forEach(function (portfolioEntity) {
                    total += _this.getTotalViableWeightFromScenarioEntity(allocationOptions, portfolioEntity);
                });
            }
        }
        return total;
    };
    BreakdownAnalysisQuery.prototype.getTotalViableWeightFromScenarioEntity = function (allocationOptions, portfolioEntity) {
        var allocation = this.getAllocation(allocationOptions, portfolioEntity);
        var total = 0;
        if (allocation && allocation.values) {
            var weight_1 = portfolioEntity.weight;
            allocation.values.forEach(function (allocationValue) {
                var value = allocationValue.value;
                total += value * weight_1 / 100;
            });
        }
        return total;
    };
    BreakdownAnalysisQuery.prototype.getWeight = function (portfolioEntity) {
        var weight = (portfolioEntity.weight || 100) / 100;
        return weight;
    };
    BreakdownAnalysisQuery.prototype.getAllocation = function (allocationOptions, portfolioEntity) {
        var entity = portfolioEntity.entity;
        if (entity && !typeChecks_1.isNullOrEmpty(entity.allocations)) {
            var code_1 = allocationOptions.code;
            var allocation = entity.allocations.find(function (a) { return a.code === code_1; });
            return allocation;
        }
    };
    return BreakdownAnalysisQuery;
}(BaseQuery_1.BaseQuery));
exports.BreakdownAnalysisQuery = BreakdownAnalysisQuery;
//# sourceMappingURL=BreakdownAnalysisQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/BreakdownAnalysisQuery.js
// module id = 367
// module chunks = 1